import React from 'react';
import { LinkContainer} from 'react-router-bootstrap';
import './style.css';
import { Dropdown, Menu } from 'semantic-ui-react'



class Navigation extends React.Component {
  render() {
    return (
      <Menu className='Nav' pointing secondary stackable>
        <Dropdown item text='Meet Us' >
          <Dropdown.Menu>
            <LinkContainer to="/aboutus">
              <Dropdown.Item>Our Organization</Dropdown.Item>
            </LinkContainer>
            <LinkContainer to="/team">
              <Dropdown.Item>Management Team</Dropdown.Item>
            </LinkContainer>
            <LinkContainer to="/experts">
              <Dropdown.Item>Council of Experts</Dropdown.Item>
            </LinkContainer>

            <LinkContainer to="/capitalstructure">
              <Dropdown.Item>Capital Structure</Dropdown.Item>
            </LinkContainer>
          </Dropdown.Menu>
        </Dropdown>
        <Dropdown item text='Our Friends'>
          <Dropdown.Menu>
            <LinkContainer to="/science">
              <Dropdown.Item>Hong Kong Science Park</Dropdown.Item>
            </LinkContainer>
            <LinkContainer to="/collab">
              <Dropdown.Item>Scientific Collaborations</Dropdown.Item>
            </LinkContainer>
            <LinkContainer to="/expertise">
              <Dropdown.Item>Scientific Expertise & Capabilities</Dropdown.Item>
            </LinkContainer>
            <LinkContainer to="/smartcity">
              <Dropdown.Item>Smart City Major Projects Partner</Dropdown.Item>
            </LinkContainer>
          </Dropdown.Menu>
        </Dropdown>
        <LinkContainer to="/strategy">
          <Menu.Item>
            Investment Strategy
          </Menu.Item>
        </LinkContainer>
        <LinkContainer to="/opportunities">
          <Menu.Item>
            Economic Opportunities
          </Menu.Item>
        </LinkContainer>
        <LinkContainer to="/exitstrategy">
          <Menu.Item>
            Value-Added Strategy
          </Menu.Item>
        </LinkContainer>
        <LinkContainer to="/contactus">
          <Menu.Item>
            Contact Us
          </Menu.Item>
        </LinkContainer>
      </Menu>
    );
  }
}

export default Navigation;

// <LinkContainer to="/board">
//   <Dropdown.Item>Board of Directors</Dropdown.Item>
// </LinkContainer>
